<template>
  <div class="container">
    <div class="container_top">
      <div class="container_top_text">
        <van-image :src="require('../../assets/img/jihuo.png')"></van-image>
        <p class="word">UKE总数</p>
        <p class="word">{{ report.totalNum }}</p>
      </div>
      
      <div class="container_top_text2">
        <van-image
          :src="require('../../assets/img/lvzhou_zongshu.png')"
        ></van-image>
        
         <p class="word">UKEY激活</p>
        
        <p class="word">{{ report.activationNum }}</p>
      </div>
      <div class="container_top_text3">
        <van-image :src="require('../../assets/img/failure.png')"></van-image>
        <p class="word">UKE吊销</p>
        <p class="word">{{ report.revocationNum }}</p>
      </div>
    </div>
    <van-list
      class="listall"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell class="listall-name" v-for="(item, index) in list" :key="index">
        <div class="list-list-content" v-if="item.certStatus == 4">
          <span class="list-lsit-text">激活</span
          ><span class="list-lsit-text2">KeyID:&nbsp;&nbsp;</span
          ><span class="list-list-text3">{{ item.keyId }}</span>
        </div>
        <div class="list-list-content" v-else>
          <span class="list-list-text2">吊销</span
          ><span class="list-lsit-text2">KeyID:&nbsp;&nbsp;</span
          ><span class="list-list-text3">{{ item.keyId }}</span>
        </div>
        <div class="list-list-content">
          证书起止日期:&nbsp;&nbsp;{{
            item.notBefore != "-" ? item.notBefore : ""
          }}
        </div>
      </van-cell>
    </van-list>
    <!-- <div class="placeholder">
      <van-button class="btn" @click.native="onAdd()">返回</van-button>
    </div> -->
    <!-- <div class="placeholder"></div> -->
  </div>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  Button,
  CellGroup,
  Cell,
  List,
  Image,
} from "vant";
import api from "@/api";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [List.name]: List,

    [Image.name]: Image,
  },
  data() {
    return {
      list: [],
      finished: false,
      loading: false,
      page: 0,
      limit: "10",
      show: false,
      report: {},
    };
  },
  created() {
    this.getReport();
    // this.getPage()
  },
  methods: {
    onAdd() {
      this.$router.go(-1);
    },
    getReport() {
      api.ukey.getReport().then((res) => {
        if (res.code == 0) {
          this.report = res;
        }
      });
    },
    onLoad() {
      this.page += 1;
      this.getPage();
    },
    getPage() {
      this.loading = true;
      const param = {
        page: this.page,
        limit: this.limit,
      };
      api.ukey.getPage(param).then((res) => {
        if (res.code === 0) {
          if (this.page === 1) {
            this.list = res.data;
          } else {
            this.list = [...this.list, ...res.data];
          }

          this.loading = false;
          if (this.list.length >= res.totalPage) {
            this.finished = true;
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  .container_top {
    // width: 100%;
    display: flex;
    // margin-top: 0.5rem;
    background-color: #f8f8f8;
    margin-left: 1.9333326vw;
    .container_top_text {
      width: 27.9333261vw;
      height: 23.999994vw;
      margin-top: 4.5333322vw;
      background-color: #1888f4;
      border-radius: 3vw;
      text-align: center;

      .van-image {
        margin-top: 2.666666vw;
        width: 7.5999981vw;
        height: 7.7333314vw;
      }
      .word {
        color: #fff;
        font-size: 3.999999vw;
        line-height: 5.5666656vw;
      }
    }
    .container_top_text2 {
      width: 28.9333261vw;
      height: 23.999994vw;
      margin-top: 4.5333322vw;
      margin-left: 4.3999989vw;
      background-color: #5eb974;
      border-radius: 3vw;
      text-align: center;

      .van-image {
        margin-top: 2.666666vw;
        width: 7.5999981vw;
        height: 7.7333314vw;
      }
      .word {
        color: #fff;
        font-size: 3.999999vw;
        line-height: 5.5666656vw;
      }
    }
    .container_top_text3 {
      width: 28.9333261vw;
      height: 23.999994vw;
      margin-top: 4.5333322vw;
      margin-left: 4.3999989vw;
      background-color: #faa105;
      border-radius: 3vw;
      text-align: center;

      .van-image {
        margin-top: 2.666666vw;
        width: 7.5999981vw;
        height: 7.7333314vw;
      }
      .word {
        color: #fff;
        font-size: 3.999999vw;
        line-height: 5.5666656vw;
      }
    }
  }
  .listall {
    margin-top: 0.6rem;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    height: 75%;
    overflow: auto;
  }
  .listall-name {
    border-radius: 0.6rem;
    margin-bottom: 1.3999989vw;

    .list-list-content {
      margin-top: 0.3rem;
      color: #666666;
      font-size: 3.1999992vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .list-lsit-text {
        display: inline-block;
        text-align: center;
        font-size: 2.9333326vw;
        width: 8.7999978vw;
        height: 4.7999988vw;
        line-height: 5vw;
        background-color: #1888f4;
        color: #fff;
        border-radius: 1vw;
      }
      .list-list-text2 {
        display: inline-block;
        text-align: center;
        font-size: 2.9333326vw;
        width: 8.7999978vw;
        height: 4.7999988vw;
        line-height: 5vw;
        background-color: #faa105;
        color: #fff;
        border-radius: 1vw;
      }
      .list-lsit-text2 {
        font-size: 3.999999vw;
        color: #333333;
        margin-left: 0.5vw;
      }
      .list-list-text3 {
        font-size: 3.999999vw;
        color: #666666;
      }
    }
  }
  .placeholder {
    width: 100%;
    margin-bottom: 7.5999981vw;
    // height:100%;
    // display: block;
    .btn {
      margin-bottom: 5vw;
      cursor: pointer;
      display: block;
      margin: auto;
      width: 90%;
      background: #1888f4;
      font-size: 4.5333322vw;
      color: #fff;
      border-radius: 2rem;
    }
  }
}
</style>